import checkout2Enabled from '@/navigation/CSR/goToCheckout/checkout2Enabled'

interface onCheckoutClickPathProps {
  isLogged: boolean
  addressId: string
  opsModel: string
  suggestProducts: boolean
}

const onCheckoutClickPath = ({
  isLogged,
  addressId,
  opsModel,
  suggestProducts,
}: onCheckoutClickPathProps) => {
  if (!isLogged) {
    return '/login?redirectToCheckout=1'
  }
  if (!addressId && opsModel === 'DELIVERY') {
    return '/location2'
  }
  if (suggestProducts) {
    return '/suggestedProducts2'
  }
  const ischeckoutEnabledV2 = checkout2Enabled() || false
  if (ischeckoutEnabledV2) {
    return '/checkout2'
  }
  return '/checkout'
}

export default onCheckoutClickPath
